import { createRoute } from "@tanstack/react-router";
import { Target } from "lucide-react";
import { Suspense } from "react";
import { useDocumentTitle } from "usehooks-ts";
import { z } from "zod";
import ContentFrame from "@/components/ContentFrame";
import SidePanel from "@/components/SidePanel";
import SimpleTaskListHeader from "@/components/SimpleTaskListHeader";
import TaskListRouteSkeleton from "@/components/TaskListRouteSkeleton";
import { TaskQueryParamsProvider } from "@/components/task-table/TaskQueryParamsContext";
import TasksTable from "@/components/task-table/TasksTable";
import { useRouteTaskQueryParams } from "@/hooks/task-query-params/useRouteTaskQueryParams";
import { appRoute } from "./appRoute";

const assignedToMeSearchSchema = z.object({
    task: z.coerce.number().optional(),
    filter: z.any().optional(),
    tab: z.string().optional(),
});

function AssignedToMePage() {
    useDocumentTitle(`Assigned to me - Orsane`);
    const queryParams = useRouteTaskQueryParams({ taskListId: undefined, type: "assigned-to-me" });

    return (
        <ContentFrame>
            <TaskQueryParamsProvider value={queryParams}>
                <Suspense fallback={<TaskListRouteSkeleton />}>
                    <SimpleTaskListHeader title="Assigned to me" icon={Target} />
                    <TasksTable key="tasklist-assigned-to-me" disabled={false} />
                </Suspense>

                {/* Right Panel */}
                <SidePanel />
            </TaskQueryParamsProvider>
        </ContentFrame>
    );
}

export const assignedToMeRoute = createRoute({
    getParentRoute: () => appRoute,
    path: "/assigned-to-me",
    validateSearch: assignedToMeSearchSchema,
    component: AssignedToMePage,
});
